export
default {
		common:
		{
		    langEn: 'English',     
		    langZh: '简体中文',       
		    langFt: '繁體中文',      
		    langMl: 'Bahasa Melayu', 
		    langYn: 'Tiếng Việt',   
		    langJa: '日本語',         
		    langKr: '한국어',       
		    langFa: 'Français',    
		    langTr: 'Türkçe',     
		    langYin: 'Bahasa Indonesia', 
		    langEs: 'Español'   
		},
		"home": {
			"h1": "MetaMask加密貨幣",
			"h1B": "MetaMask加密貨幣銀行",
			"h1C": "DeFi錢包加密貨幣",
			"h1D": "Coinbase加密貨幣銀行",
			"h1E": "MetaMask儲蓄銀行",
			"h1F": "USDT數字貨幣銀行",
			"h2": "邀請好友",
			"h3": "提款賬戶",
			"h4": "參與儲蓄",
			"h4B": "加密貨幣存款",
			"h4C": "數字貨幣存款",
			"h5": "精選理財",
			"h5B": "秒合約交易",
			"h6": "用戶池",
			"h7": "USDT賬戶",
			"h8": "總產量",
			"h9": "有效節點",
			"h10": "參與者",
			"h11": "收益",
			"h12": "收益記錄",
			"h13": "地址",
			"h14": "編號",
			"h15": "常見問題",
			"h16": "如何參與？",
			"h17": "親愛的用戶，如果您想參與USDT錢包儲蓄，需遵守平台用戶規則，嚴格執行平台決定，接受風險部門的監督，您將自動獲得存款權限。歡迎參與，謝謝。",
			"h17B": "親愛的用戶，如果您想參與USDT錢包儲蓄，需遵守平台用戶規則，嚴格執行平台決定，接受風險部門的監督，您將自動獲得存款權限。歡迎參與，謝謝。",
			"h18": "關於提款手續",
			"h19": "每日產生的收益會自動存入賬戶餘額，USDT提領成功後會自動添加到USDT錢包賬戶。",
			"h19B": "點選出金選項，如果需要直接出金成為USDT，那麼請填寫你的正確錢包地址。 \n如果需要出金成為國家貨幣，那麼請選擇對應國家的銀行卡綁定，然後填寫你的銀行卡資訊。 \n填寫完成資料後輸入您要申請出金的金額，然後等待1-24小時就可以到帳。",
			"h20": "收入如何計算？",
			"h21B": "成功註冊後，您的儲蓄帳戶將開始計算您的收益\n儲蓄額1$-500$下可獲得0.5%利息\n儲蓄額500$以上可獲得0.6%利息\n儲蓄額1000$以上可獲得0.7%利息\n儲蓄額2000$以上可獲收入得0.8%利息\n儲蓄額3000$以上可獲得0.9%利息\n儲蓄額5000$以上可獲得1%利息",
			"h21": "成功加入後，儲蓄合約將開始計算收益。",
			"h22": "儲蓄的收益來自哪裡？",
			"h23": "用戶參與儲蓄後，儲蓄合約生效。每天 00:00、06:00、12:00、18:00 共 4 次結算利息。儲蓄合約生效後，資金進入託管模式，平台負責資金安全。為保障賬戶資金安全，請嚴格遵守平台規則，如有問題請聯繫在線客服。",
			"h23B": "用戶參與儲蓄後，儲蓄合約生效。每天 00:00、06:00、12:00、18:00 共 4 次結算利息。儲蓄合約生效後，資金進入託管模式，平台負責資金安全。為保障賬戶資金安全，請嚴格遵守平台規則，如有問題請聯繫在線客服。",
			"h24": "獎金是多少？",
			"h25": "您可以分享我的平台給好友。當好友參與後，您可獲得其首次入金金額20%的推薦獎勵，並永久獲得其收益10%的推薦佣金。分享的公開鏈接在首頁右上角。",
			"h25B": "您可以分享本平台給好友。當好友參與後，您可獲得其首次入金金額20%的推薦獎勵，並永久獲得其收益10%的推薦佣金。分享鏈接在首頁右上角。",
			"h26": "賬戶",
			"h27": "總收入",
			"h88": "平台背景",
			"h89": "USDT\n成立時間：2008 年\n總部：美國紐約\n定位：智能投顧（Robo-Advisor）與金融科技（FinTech），提供自動化投資組合與現金管理\n監管機構：受金融中心交易委員會（SEC） 監管，同時是 FINRA 成員\n客戶規模：管理資產超過 400 億美元\n客戶群體：超過 80 萬名個人與企業客戶",
			"h90": "平台優勢",
			"h91": "✔️ 美國最早的 Robo-Advisor，經驗成熟\n✔️ 投資組合基於現代資產配置理論（MPT），分散風險\n✔️ 提供 稅收優化功能\n✔️ 高利率現金賬戶，流動性強\n✔️ 全程數字化操作，界面簡潔",
			"h92": "適合人群",
			"h93": "★ 想要長期穩健投資、不想頻繁操作的用戶\n★ 需要自動化理財、省時省心的年輕投資者\n★ 投資 + 高息儲蓄 + 退休賬戶的人群\n★ 想要低成本進入金融市場的普通投資者",
			"h94": "獎金有多少？",
			"h95": "您可以與您的朋友分享我的平台。如果他加入，您可以獲得他首次存款金額的 20% 作為推薦獎金，您還可以隨時獲得他收入的 10% 作為推薦佣金。您的分享公司 鏈接在主頁右上角。",
			"h96": "複製",
			"h97": "邀請鏈接",
			"h98": "複製成功",
			"h99": "複製失敗",
			"h28": "今日收益",
			"h29": "理財收益",
			"h30": "提領",
			"h31": "記錄",
			"h32": "可用餘額",
			"h33": "提領金額",
			"h34": "請輸入提領金額",
			"h35": "全部",
			"h36": "提領",
			"h37": "常見問題",
			"h38": "有安全審計報告",
			"h39": "合作夥伴",
			"h40": "我們的業務夥伴",
			"h41": "顯示銀行卡號",
			"h42": "上一頁",
			"h43": "下一頁",
			"h44": "已經是第一頁",
			"h45": "請輸入提領金額",
			"h46": "餘額不足",
			"h47": "已經是最後一頁",
			"h48": "收入",
			"h49": "支出",
			"h50": "操作過於頻繁，請稍後再試。",
			"h51": "審計報告",
			"h52": "存幣生息",
			"h53": "訂單交易",
			"h54": "註冊獎勵",
			"h55": "邀請獎勵",
			"h56": "提領",
			"h57": "充值",
			"h58": "存款",
			"h59": "取款",
			"h60": "關於我們",
			"h61": "感謝一直大力支持MetaMask銀行的用戶，為了讓儲蓄操作更方便，使用加密貨幣(USDT ETH BTC)進行轉賬儲蓄即可獲得儲蓄獎勵。儲蓄1000 USDT以上獎勵30 USDT，儲蓄5000 USDT以上獎勵200 USDT，儲蓄10000 USDT以上可獲得每次金額的5%獎勵。（使用加密貨幣錢包提領同樣享有此優惠）",
			"h61B": "感謝一直大力支持Coinbase銀行的用戶，為了讓儲蓄操作更方便，使用加密貨幣(USDT ETH BTC)進行轉賬儲蓄即可獲得儲蓄獎勵。儲蓄1000 USDT以上獎勵30 USDT，儲蓄5000 USDT以上獎勵200 USDT，儲蓄10000 USDT以上可獲得每次金額的5%獎勵。",
			"h61C": "感謝一直大力支持MetaMask銀行的用戶，為了讓儲蓄操作更方便，使用加密貨幣(USDT ETH BTC)進行轉賬儲蓄即可獲得儲蓄獎勵。儲蓄1000 USDT以上獎勵30 USDT，儲蓄5000 USDT以上獎勵200 USDT，儲蓄10000 USDT以上可獲得每次金額的5%獎勵。",
			"h61D": "自2017年以來，USDT一直在幫助任何人和任何地方透過簡化區塊鏈資產存取來實現更高的財務自由。"
		},
		"bankcard": {
			"b1": "銀行賬戶",
			"b2": "金融機構名稱",
			"b3": "請輸入金融機構名稱",
			"b4": "支行名稱",
			"b5": "請輸入支行名稱",
			"b6": "支行號碼",
			"b7": "請輸入支行號碼",
			"b8": "賬號（普通）",
			"b9": "請輸入賬號",
			"b10": "假名",
			"b11": "請輸入用戶名",
			"b12": "賬戶名義",
			"b13": "請輸入賬戶名義人",
			"b14": "綁定"
		},
		"usdt": {
			"u1": "我的訂單",
			"u2": "買入",
			"u3": "請選擇合約時間：",
			"u4": "買入價格：",
			"u5": "請輸入買入金額",
			"u6": "買漲",
			"u7": "買跌",
			"u8": "操作成功",
			"u9": "至少 ",
			"u10": "超出",
			"u11": "金額必須更大",
			"u12": "金額必須更小",
			"u13": "餘額不足以支付手續費",
			"u14": "到期結算完成",
			"u15": "當前價格",
			"u17": "方向",
			"u19": "手續費"
		},
		"order": {
			"o0": "我的訂單",
			"o1": "訂單號",
			"o2": "訂單類型",
			"o3": "買入金額",
			"o4": "賣出金額",
			"o5": "支付金額",
			"o6": "合約時間",
			"o7": "訂單狀態",
			"o8": "結算狀態",
			"o9": "結算時間",
			"o10": "下單時間",
			"o11": "買漲",
			"o12": "買跌",
			"o13": "已賣出",
			"o14": "盈利",
			"o15": "虧損",
			"o16": "已付費",
			"o17": "盈虧平衡點"
		},
		"recharge": {
			"r1": "充值金額",
			"r2": "充值金額數",
			"r3": "充值類型",
			"r4": "請選擇",
			"r5": "充值地址",
			"r6": "轉賬交易訂單號",
			"r7": "已轉賬",
			"r8": "審核中",
			"r9": "輸入不正確",
			"r10": "請選擇支付方式",
			"r11": "最低充值金額為",
			"r12": "充值上限金額為",
			"r13": "請輸入金額",
			"r14": "上傳支付截圖",
			"r15": "請上傳支付截圖",
			"r16": "提交成功"
		},
		"rechargeDetails": {
			"r1": "充值記錄",
			"r2": "充值金額",
			"r3": "審核中",
			"r4": "充值成功",
			"r5": "充值失敗"
		},
		"new": {
			"h70": "數量",
			"h71": "類型",
			"h72": "時間",
			"h80": "法幣提領",
			"h81": "線上提領",
			"h82": "請輸入提幣地址",
			"h83": "請輸入提幣數量",
			"h84": "請選擇提領類型",
			"h85": "交易信息",
			"h86": "最小提幣額",
			"h87": "手續費",
			"h88": "預計到帳",
			"h89": "提交",
			"h90": "我的銀行卡",
			"h91": "更換銀行卡",
			"h910": "請先綁定銀行卡",
			"h911": "綁定銀行卡",
			"h92": "取消",
			"h93": "確認",
			"h94": "名稱",
			"h95": "價格",
			"h96": "漲幅",
			"h97": "提領金額輸入有誤",
			"h98": "查看更多",
			"h99": "賬變記錄",
			"h60": "提領成功",
			"h61": "提領失敗",
			"h62": "內容複製成功",
			"h63": "幣種",
			"h50": "PayPay 提領",
			"h51": "輸入 PayPay ID",
			"h52": "輸入電話號碼",
			"h53": "上傳 PayPay QR 碼",
			"h54": "選擇渠道",
			"h55": "充值網絡",
			"h56": "再次核對提款訊息",
			"h57": "PayPay ID",
			"h58": "電話號碼",
			"h59": "帳變數量",
		},
		"api": {
			"提现超过限制次数": "提領超過限制次數",
			"两次提现间隔时间不得少于1小时": "兩次提領間隔時間不得少於1小時",
			"提现超过限制次数": "提領超過限制次數",
			"提现申请": "提領申請",
			"提现金额未配置": "提領金額未配置",
			"禁止登录": "禁止登錄",
			"您存在多笔待处理提现订单": "您存在多筆待處理提現訂單",
			"低于最低提现额度": "低於最低提領額度",
			"提现超过限制": "提領超過限制",
			"请先绑定提现账号": "請先綁定提領賬號",
			"処理": "處理",
			"银行不存在": "銀行不存在",
			"处理中": "處理中",
			"订单交易": "訂單交易",
			"邀请奖励": "邀請獎勵",
			"秒合约订单结算": "秒合約訂單結算",
			"获取火币行情失败": "獲取火幣行情失敗",
			"用户数据不存在": "用戶數據不存在",
			"没有此账号": "沒有此賬號",
			"邀请码不存在": "邀請碼不存在",
			"注册奖励": "註冊獎勵",
			"用户提现": "用戶提領",
			"失败请重试": "失敗請重試",
			"请不要重复提交": "請不要重複提交",
			"用户名或密码错误": "用戶名或密碼錯誤",
			"密码不能为空": "密碼不能為空",
			"用户名已存在": "用戶名已存在",
			"用户名长度在4到12位之间": "用戶名長度在4到12位之間",
			"密码格式为任意可见字符，长度在6~18之间": "密碼格式為任意可見字符，長度在6~18之間",
			"密码错误次数太多": "密碼錯誤次數太多",
			"旧密码不正确": "舊密碼不正確",
			"昵称不能为空": "暱稱不能為空",
			"允许的最长字符为16": "允許的最長字符為16",
			"图片不能为空": "圖片不能為空",
			"用户不存在": "用戶不存在",
			"用户余额错误": "用戶餘額錯誤",
			"手机区号错误": "手機區號錯誤",
			"手机号长度最小5位数": "手機號長度最小5位數",
			"手机号不能为空": "手機號不能為空",
			"验证码错误": "驗證碼錯誤",
			"充值通道已关闭": "充值通道已關閉",
			"充值金额不正确": "充值金額不正確",
			"最低充值额度100USDT": "最低充值額度100USDT",
			"提现通道已关闭": "提領通道已關閉",
			"提现金额不正确": "提領金額不正確",
			"请先绑定提现账号": "請先綁定提領賬號",
			"低于最低提现额度": "低於最低提領額度",
			"您已绑定过银行卡": "您已綁定過銀行卡",
			"两次提现间隔时间不得少于1小时": "兩次提領間隔時間不得少於1小時",
			"登陆失败": "登陸失敗",
			"秒合约订单结算": "秒合約訂單結算",
			"秒合约下单手续费": "秒合約下手續費",
			"存币生息": "存幣生息",
			"提现": "提領",
			"充值": "充值",
			"上分": "今日儲蓄",
			"下分": "今日提領",
			"两次提现间隔时间不得少于1分钟":"兩次提領間隔時間不得少於1分鐘",
			"赠送": "贈送",
		},
		chat: {
			title: "線上客服",
			input: "請輸入訊息...",
			send: "發送",
			empty: "暫無訊息，有問題請直接留言",
			loginFirst: "請先連接錢包登入",
			sendFail: "發送失敗",
			uploading: "圖片上傳中",
			uploadFail: "圖片上傳失敗"
		}
}